<template>
  <div class="header">
    <img src="@/assets/logo1.png"/>
    <div class="header-title">
      <div :class="['title', type==='home'?'title-click':'']" @click="goPage('home')">首页</div>
      <div :class="['title', type==='product'?'title-click':'']" @click="goPage('product')">产品/服务</div>
      <div :class="['title', type==='contact'?'title-click':'']" @click="goPage('contact')">联系我们</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
      type: 'home', // home首页product产品服务contact联系我们
    }
  },
  watch: {
    '$route'(to) {
      // 当路由变化时，执行一些操作
      this.type = to.path.split('/')[2]
      console.log('Route changed from', to.path.split('/')[2]);
    }
  },
  methods: {
    goPage(data) {
      if (this.type === data) return
      this.type = data
      this.$router.push({path: data})
    }
  }
}
</script>
<style scoped lang="scss">
.header {
    width: 100%;
    height:80px;
    background:#000209;
    padding: 0 80px;
    display: flex;
    justify-content:space-between;
    align-items: center;
    img {
      width: 156px;
      height: 56px;
    }
    .header-title {
       height: 100%;
       display: flex;
      .title {
        min-width: 40px;
        height: 76px;
        padding: 0 20px;
        font-family:Source Han Sans CN;
        font-weight:700;
        color:rgba(255, 255, 255, 0.6);
        font-size:20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
        cursor: pointer;
      }
      .title-click {
        color: #ffffff;
        border-bottom: 4px solid #fff;
      }
      .title:hover {
        color: #ffffff;
        border-bottom: unset;
      }
      .title-click:hover {
        color: #ffffff;
        border-bottom: 4px solid #fff;
      }
    }
  }
</style>
